import { i as e, n as t, r as n, t as r } from "./constants-DCmUtbcH.js";
import { FALLBACK_LANGUAGE as i, LocaleProvider as a, findLocale as o, resolveBrowserLocale as s, resolveLocale as c } from "@frontends/util-i18n";
import { ThemeProvider as l, isThemeMode as u } from "@frontends/util-theme-provider";
import { createContext as d, useCallback as f, useContext as p, useEffect as m, useMemo as h, useRef as g, useState as ee } from "react";
import { jsx as _ } from "react/jsx-runtime";
import { getCookie as v, setCookie as y } from "@frontends/util-utils";
//#region src/lib/state/isTimezone.ts
function b(e) {
	if (!e) return !1;
	try {
		return Intl.DateTimeFormat(void 0, { timeZone: e }).resolvedOptions().timeZone !== "";
	} catch {
		return !1;
	}
}
//#endregion
//#region src/lib/state/readChoice.ts
function x(e) {
	if (typeof e != "object" || !e) return null;
	let { themeMode: t, language: n, timezone: r } = e, i = {};
	typeof t == "string" && u(t) && (i.themeMode = t);
	let a = typeof n == "string" ? c(n) : null;
	return a && (i.language = a.language), typeof r == "string" && b(r) && (i.timezone = r), Object.keys(i).length > 0 ? i : null;
}
//#endregion
//#region src/lib/frames/frameMessages.ts
var S = "themeToggleEvent";
function te(e) {
	if (typeof e != "object" || !e) return null;
	let t = e;
	if (t.type !== "themeToggleEvent" || typeof t.payload != "object") return null;
	let { theme: n, language: r, timezone: i } = t.payload ?? {};
	return x({
		themeMode: n,
		language: r,
		timezone: i
	});
}
function ne(e, t) {
	if (typeof window > "u" || window.parent === window) return;
	let n = {
		type: S,
		payload: {
			theme: e.themeMode,
			language: e.language,
			timezone: e.timezone
		}
	};
	window.parent.postMessage(n, t);
}
//#endregion
//#region src/lib/context/PreferencesContext.ts
var re = d(null);
//#endregion
//#region src/lib/hooks/usePreferences.ts
function C() {
	let e = p(re);
	if (!e) throw Error("usePreferences must be used within a PreferencesProvider");
	return e;
}
//#endregion
//#region src/lib/providers/PreferencesBridge.tsx
function w({ offeredLanguages: e, children: t }) {
	let { themeMode: n, language: r, setThemeMode: i, setLanguage: s } = C(), c = f((e) => s(e.language), [s]);
	return /* @__PURE__ */ _(l, {
		mode: n,
		onModeChange: i,
		children: /* @__PURE__ */ _(a, {
			locale: o(r),
			offeredLanguages: e,
			onLocaleChange: c,
			children: t
		})
	});
}
//#endregion
//#region src/lib/state/localState.ts
function T(e, t, n, r) {
	return t === void 0 ? e : {
		value: t,
		source: n,
		author: r
	};
}
function E(e, t, n, r) {
	return {
		themeMode: T(e.themeMode, t.themeMode, n, r),
		language: T(e.language, t.language, n, r),
		timezone: T(e.timezone, t.timezone, n, r)
	};
}
function ie(e, t, n) {
	return E(e, t, "choice", n);
}
function ae(e, t, n) {
	return E(e, t, "adopted", n);
}
function oe(e, t) {
	return {
		themeMode: {
			value: e.themeMode,
			source: "cookie",
			author: t
		},
		language: {
			value: e.language,
			source: "cookie",
			author: t
		},
		timezone: {
			value: e.timezone,
			source: "cookie",
			author: t
		}
	};
}
function D(e) {
	return {
		themeMode: e.themeMode.value,
		language: e.language.value,
		timezone: e.timezone.value
	};
}
function O(e) {
	return e.source === "choice" || e.source === "adopted";
}
//#endregion
//#region src/lib/cookies/browserCookies.ts
function k(e) {
	return e instanceof DOMException && e.name === "SecurityError";
}
function A(e) {
	try {
		return v(e);
	} catch (e) {
		if (k(e)) return null;
		throw e;
	}
}
function j(e, t) {
	try {
		y(e, t);
	} catch (e) {
		if (!k(e)) throw e;
	}
}
//#endregion
//#region src/lib/cookies/authorTags.ts
var M = {
	themeMode: null,
	language: null,
	timezone: null
};
function N(e) {
	if (!e) return { ...M };
	if (!e.includes(":")) return {
		themeMode: e,
		language: e,
		timezone: e
	};
	let t = { ...M };
	for (let n of e.split("|")) {
		let [e, r] = n.split(":");
		e in t && (t[e] = r || null);
	}
	return t;
}
function P(e) {
	return new Set(n.map((t) => e[t])).size === 1 ? e.themeMode ?? "" : n.map((t) => `${t}:${e[t] ?? ""}`).join("|");
}
function F() {
	return N(A(r));
}
function I(e, t = n) {
	let i = F();
	for (let n of t) i[n] = e;
	j(r, P(i));
}
//#endregion
//#region src/lib/cookies/cookieState.ts
function L() {
	let e = F(), n = A(t.themeMode), r = c(A(t.language)), i = A(t.timezone);
	return {
		themeMode: u(n) ? {
			value: n,
			source: "cookie",
			author: e.themeMode
		} : null,
		language: r ? {
			value: r.language,
			source: "cookie",
			author: e.language
		} : null,
		timezone: b(i) ? {
			value: i,
			source: "cookie",
			author: e.timezone
		} : null
	};
}
function R(e, r = n) {
	for (let n of r) j(t[n], String(e[n]));
}
function se(e, t) {
	R(D(e), t);
	let n = new Set(t.map((t) => e[t].author));
	for (let r of n) I(r, t.filter((t) => e[t].author === r));
}
function ce(e, t) {
	return n.flatMap((n) => {
		let r = e[n], i = t[n], a = r !== null && i !== null && r.value === i.value && r.author === i.author;
		return i === null || a ? [] : [{
			field: n,
			value: i.value,
			author: i.author
		}];
	});
}
//#endregion
//#region src/lib/state/address.ts
function z(e) {
	return typeof window > "u" ? null : new URLSearchParams(window.location.search).get(e);
}
function B(t = n) {
	if (typeof window > "u") return;
	let r = new URL(window.location.href), i = Object.entries(e).filter(([e, n]) => t.includes(e) && r.searchParams.has(n)).map(([, e]) => e);
	if (i.length !== 0) {
		for (let e of i) r.searchParams.delete(e);
		window.history.replaceState(window.history.state, document.title, r.pathname + r.search + r.hash);
	}
}
//#endregion
//#region src/lib/cookies/watchCookies.ts
var V = [...Object.values(t), r], le = 700, ue = 30;
function de() {
	let e = globalThis.cookieStore;
	return e && typeof e.addEventListener == "function" ? e : null;
}
function fe() {
	return V.map((e) => `${e}=${A(e) ?? ""}`).join("&");
}
function pe(e, t) {
	let n = null, r = (e) => {
		![...e.changed ?? [], ...e.deleted ?? []].some((e) => V.includes(e.name)) || n !== null || (n = setTimeout(() => {
			n = null, t();
		}, ue));
	};
	return e.addEventListener("change", r), () => {
		n !== null && (clearTimeout(n), n = null), e.removeEventListener("change", r);
	};
}
function me(e) {
	let t = fe(), n = null, r = () => {
		let n = fe();
		n !== t && (t = n, e());
	}, i = () => {
		n === null && (n = setInterval(r, le));
	}, a = () => {
		n !== null && (clearInterval(n), n = null);
	}, o = () => {
		if (document.visibilityState === "visible") {
			r(), i();
			return;
		}
		a();
	};
	return document.addEventListener("visibilitychange", o), document.visibilityState === "visible" && i(), () => {
		a(), document.removeEventListener("visibilitychange", o);
	};
}
function he(e) {
	let t = de();
	return t ? pe(t, e) : typeof document > "u" ? () => void 0 : me(e);
}
//#endregion
//#region src/lib/cookies/useSharedCookies.ts
function ge({ stripQueryParams: e, localStateRef: t, writeToCookies: r, refresh: i }) {
	m(() => {
		let i = t.current;
		if (r(n.filter((e) => i[e].source === "choice")), e) {
			let e = L(), t = D(i);
			B(n.filter((n) => e[n]?.value === t[n]));
		}
	}, [
		e,
		t,
		r
	]), m(() => {
		if (typeof window > "u") return;
		let e = () => {
			document.visibilityState === "visible" && i();
		}, t = (e) => {
			e.persisted && i();
		}, n = he(i);
		return document.addEventListener("visibilitychange", e), window.addEventListener("focus", e), window.addEventListener("pageshow", t), () => {
			n(), document.removeEventListener("visibilitychange", e), window.removeEventListener("focus", e), window.removeEventListener("pageshow", t);
		};
	}, [i]);
}
//#endregion
//#region src/lib/frames/frameOrigins.ts
function H(e) {
	if (!e) return null;
	try {
		return new URL(e).origin;
	} catch {
		return null;
	}
}
function _e() {
	if (typeof window > "u" || window.parent === window) return null;
	let e = window.location.ancestorOrigins;
	return e && e.length > 0 ? e[0] : H(document.referrer);
}
function ve(e) {
	let t = (Array.isArray(e) ? e : [e]).map(H).filter((e) => e !== null);
	if (t.length === 0) return null;
	let n = _e();
	return n !== null && t.includes(n) ? n : null;
}
//#endregion
//#region src/lib/frames/useEmbeddedChoices.ts
function ye(e, t) {
	m(() => {
		if (typeof window > "u" || !e) return;
		let n = (n) => {
			if (n.origin !== e) return;
			let r = te(n.data);
			r && t(r);
		};
		return window.addEventListener("message", n), () => window.removeEventListener("message", n);
	}, [e, t]);
}
//#endregion
//#region src/lib/hooks/useLatestRef.ts
function U(e) {
	let t = g(e);
	return t.current = e, t;
}
//#endregion
//#region src/lib/hooks/useLazyRef.ts
function W(e) {
	let t = g(null);
	return t.current === null && (t.current = e()), t;
}
//#endregion
//#region src/lib/owner.ts
var be = 2166136261, xe = 16777619;
function G(e) {
	return e ? `${e.kind}:${e.id}` : null;
}
function Se(e) {
	let t = be;
	for (let n = 0; n < e.length; n++) t ^= e.charCodeAt(n), t = Math.imul(t, xe);
	return (t >>> 0).toString(16).padStart(8, "0");
}
function Ce(e) {
	return e ? Se(G(e)) : null;
}
//#endregion
//#region src/lib/row/mergeWithRow.ts
function we(e, t) {
	return e.author === null || e.author === t;
}
function Te(e, t) {
	return e.source === "adopted" && e.author === t;
}
function K(e, t, n, r) {
	return O(e) && we(e, r) ? {
		shown: e.value,
		save: !Te(e, r)
	} : t === null ? {
		shown: we(e, r) ? e.value : n,
		save: !0
	} : {
		shown: t,
		save: !1
	};
}
function Ee(e, t, r, i) {
	let a = {
		themeMode: K(e.themeMode, t ? t.themeMode : null, r.themeMode, i),
		language: K(e.language, t ? t.language : null, r.language, i),
		timezone: K(e.timezone, t ? t.timezone : null, r.timezone, i)
	};
	return {
		shown: {
			themeMode: a.themeMode.shown,
			language: a.language.shown,
			timezone: a.timezone.shown
		},
		fieldsToSave: n.filter((e) => a[e].save)
	};
}
//#endregion
//#region src/lib/row/httpStatus.ts
function De(e, t) {
	if (typeof e != "object" || !e) return !1;
	let n = e;
	return [
		n.response?.status,
		n.status,
		n.httpStatus,
		n.code
	].some((e) => typeof e == "number" && t.includes(e)) ? !0 : ([
		n.errors,
		n.items,
		n.response?.data?.errors
	].find(Array.isArray) ?? []).some((e) => typeof e?.status == "number" && t.includes(e.status));
}
//#endregion
//#region src/lib/row/saveQueue.ts
var Oe = 15e3, ke = [400, 422];
function q(e, t) {
	return G(e.owner) === G(t.owner);
}
function Ae(e, t, n) {
	return {
		themeMode: n("themeMode") ? t.themeMode : e.themeMode,
		language: n("language") ? t.language : e.language,
		timezone: n("timezone") ? t.timezone : e.timezone
	};
}
function J(e, t) {
	let r = (n) => e.fields.includes(n) && !t.fields.includes(n);
	return {
		...t,
		snapshot: Ae(t.snapshot, e.snapshot, r),
		fields: n.filter((n) => e.fields.includes(n) || t.fields.includes(n))
	};
}
function Y(e, t, n) {
	if (!e) return null;
	let r = (t) => n.includes(t) && e.fields.includes(t);
	return {
		...e,
		snapshot: Ae(e.snapshot, t, r)
	};
}
function je(e) {
	let t = !1, n = 0, r = null, i = null, a = null, o = (t) => {
		if (e) {
			e(t);
			return;
		}
		console.warn("[preferences] failed to save", t);
	}, s = (e, t, r) => r === n && !e.createsRow && !De(t, ke), c = (e) => {
		i && q(e, i) ? i = J(e, i) : i || (a = e);
	}, l = () => {
		if (t || !i) return;
		let e = i, a = n;
		i = null, r = e, t = !0;
		let u = !1, d = (e) => {
			if (u) return;
			u = !0, clearTimeout(f);
			let n = r;
			r = null;
			try {
				e && (n && s(n, e.error, a) && c(n), o(e.error));
			} finally {
				t = !1, l();
			}
		}, f = setTimeout(() => d({ error: /* @__PURE__ */ Error(`[preferences] save timed out after ${Oe} ms`) }), Oe);
		try {
			e.port.save(e.owner, e.snapshot, e.fields).then(() => d(), (e) => d({ error: e }));
		} catch (e) {
			d({ error: e });
		}
	};
	return {
		push(e, t, n, r, { createsRow: o = !1 } = {}) {
			let s = {
				port: e,
				owner: t,
				snapshot: n,
				fields: r,
				createsRow: o
			};
			i = i && q(i, s) ? J(i, s) : s, a && q(a, i) && (i = J(a, i)), a = null, l();
		},
		replaceQueuedValues(e, t) {
			r = Y(r, e, t), i = Y(i, e, t), a = Y(a, e, t);
		},
		retry() {
			a && !i && (i = a, a = null), l();
		},
		clear() {
			n += 1, i = null, a = null;
		}
	};
}
//#endregion
//#region src/lib/row/loadWithTimeout.ts
var Me = [
	1e3,
	5e3,
	15e3
], Ne = 15e3;
function Pe(e, t) {
	return new Promise((n) => {
		let r = () => {
			clearTimeout(i), t.removeEventListener("abort", r), n();
		}, i = setTimeout(r, e);
		t.addEventListener("abort", r, { once: !0 });
	});
}
function Fe(e, t, n) {
	return new Promise((r, i) => {
		if (n.aborted) {
			i(n.reason);
			return;
		}
		let a = new AbortController(), o = (e) => {
			clearTimeout(c), n.removeEventListener("abort", s), e();
		}, s = () => {
			a.abort(), o(() => i(n.reason));
		}, c = setTimeout(() => {
			a.abort(), o(() => i(/* @__PURE__ */ Error(`[preferences] load timed out after ${Ne} ms`)));
		}, Ne);
		n.addEventListener("abort", s, { once: !0 });
		try {
			e.load(t, a.signal).then((e) => o(() => r(e)), (e) => o(() => i(e)));
		} catch (e) {
			o(() => i(e));
		}
	});
}
//#endregion
//#region src/lib/row/useRowLoader.ts
function Ie({ ownerKey: e, hasPort: t, ownerRef: n, portRef: r, onLoaded: i, onResume: a, report: o }) {
	m(() => {
		if (e === null) return;
		let t = n.current, s = r.current;
		if (!t || !s) return;
		let c = new AbortController(), l = !1, u = !1, d = async () => {
			if (!(l || u || c.signal.aborted)) {
				l = !0;
				try {
					for (let e = 0;; e++) {
						let n;
						try {
							n = await Fe(s, t, c.signal);
						} catch (t) {
							if (c.signal.aborted || (e === 0 && o(t), e >= Me.length) || (await Pe(Me[e], c.signal), c.signal.aborted)) return;
							continue;
						}
						if (c.signal.aborted) return;
						u = !0, i(n, t, s);
						return;
					}
				} finally {
					l = !1;
				}
			}
		};
		d();
		let f = () => {
			a(), d();
		}, p = () => {
			document.visibilityState === "visible" && f();
		};
		return window.addEventListener("online", f), document.addEventListener("visibilitychange", p), () => {
			c.abort(), window.removeEventListener("online", f), document.removeEventListener("visibilitychange", p);
		};
	}, [
		e,
		t,
		n,
		r,
		i,
		a,
		o
	]);
}
//#endregion
//#region src/lib/state/defaults.ts
var X = {
	themeMode: "system",
	language: i,
	timezone: "UTC"
};
//#endregion
//#region src/lib/state/browser.ts
function Le() {
	return typeof window > "u" ? null : s()?.language ?? null;
}
function Re() {
	if (typeof window > "u") return null;
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
	} catch {
		return null;
	}
}
//#endregion
//#region src/lib/state/initialState.ts
function ze(e) {
	return {
		value: e,
		source: "choice",
		author: null
	};
}
function Be(e) {
	return {
		value: e,
		source: "browser",
		author: null
	};
}
function Z(e) {
	return {
		value: e,
		source: "default",
		author: null
	};
}
function Ve(t, n) {
	let r = z(e.themeMode);
	return u(r) ? ze(r) : n ?? Z(t);
}
function He(t, n) {
	let r = c(z(e.language));
	if (r) return ze(r.language);
	if (n) return n;
	let i = Le();
	return i ? Be(i) : Z(t);
}
function Ue(e, t) {
	if (t) return t;
	let n = Re();
	return n ? Be(n) : Z(e);
}
function We(e = X) {
	let t = L();
	return {
		themeMode: Ve(e.themeMode, t.themeMode),
		language: He(e.language, t.language),
		timezone: Ue(e.timezone, t.timezone)
	};
}
function Ge(e = X) {
	return {
		themeMode: e.themeMode,
		language: Le() ?? e.language,
		timezone: Re() ?? e.timezone
	};
}
//#endregion
//#region src/lib/tabs/tabsChannel.ts
var Ke = "frontends.preferences";
function qe(e) {
	let { author: t } = e;
	return t === null ? null : typeof t == "string" && t.length > 0 ? t : void 0;
}
function Je() {
	if (typeof BroadcastChannel > "u") return null;
	try {
		return new BroadcastChannel(Ke);
	} catch {
		return null;
	}
}
function Ye(e) {
	let t = Je();
	return t ? (t.onmessage = (t) => {
		let n = x(t.data);
		n && e(n, qe(t.data));
	}, {
		announce: (e, n) => t.postMessage({
			...e,
			author: n
		}),
		close: () => {
			t.onmessage = null, t.close();
		}
	}) : null;
}
//#endregion
//#region src/lib/tabs/useTabsChannel.ts
function Xe(e, t) {
	let n = g(null);
	return m(() => {
		if (!e) return;
		let r = Ye(t);
		return n.current = r, () => {
			n.current = null, r?.close();
		};
	}, [e, t]), n;
}
//#endregion
//#region src/lib/providers/PreferencesProvider.tsx
function Ze(e) {
	return e.map(({ field: e }) => e);
}
function Qe(e, t) {
	return n.flatMap((n) => {
		let r = e[n];
		return r === void 0 ? [] : [{
			field: n,
			value: r,
			author: t
		}];
	});
}
function $e({ field: e, author: t }, n, r) {
	let i = r[e] !== n[e].value, a = n[e].author !== null;
	return t === null && (i || a);
}
function et({ owner: e = null, port: t, defaults: r, persist: i = !0, stripQueryParams: a = i, onError: o, announceTo: s, embeddedFrom: c, children: l }) {
	let u = h(() => ve(s), [s]), d = h(() => H(c), [c]), p = W(() => ({
		...X,
		...r
	})), v = W(() => We(p.current)), y = W(() => Ge(p.current)), b = W(() => L()), [S, te] = ee(() => D(v.current)), C = U(e), w = U(t), T = U(o), E = f((e) => {
		if (T.current) {
			T.current(e);
			return;
		}
		console.warn("[preferences] sync failed", e);
	}, [T]), O = W(() => je(E)), [k, A] = ee(null), j = g(null), M = G(e), N = f((e) => {
		v.current = e, te(D(e));
	}, [v]), P = f((e) => {
		!i || e.length === 0 || (se(v.current, e), b.current = L());
	}, [
		i,
		v,
		b
	]), F = f((e) => {
		let t = C.current, n = w.current;
		!i || e.length === 0 || !t || !n || j.current === G(t) && O.current.push(n, t, D(v.current), e);
	}, [
		i,
		C,
		w,
		O,
		v
	]), I = f((e) => {
		if (e.length === 0) return;
		let t = v.current, n = Ce(C.current);
		N(e.reduce((e, { field: t, value: n, author: r }) => ae(e, { [t]: n }, r), t));
		let r = D(v.current), i = e.filter(({ author: e }) => n !== null && e === n), a = e.filter((e) => $e(e, t, r));
		O.current.replaceQueuedValues(r, Ze(i)), F(Ze(a));
	}, [
		v,
		C,
		N,
		O,
		F
	]), R = f(() => {
		let e = L(), t = ce(b.current, e);
		b.current = e, I(t);
	}, [b, I]), z = f((e, t, r) => {
		let a = G(t), o = Se(a);
		R();
		let { shown: s, fieldsToSave: c } = Ee(v.current, e, y.current, o);
		N(oe(s, o)), P(n), j.current = a, A(a), i && c.length > 0 && O.current.push(r, t, s, c, { createsRow: e === null });
	}, [
		i,
		R,
		v,
		y,
		N,
		P,
		O
	]), B = Xe(i, f((e, t) => {
		R(), I(Qe(e, t ?? null));
	}, [R, I])), V = f((e) => {
		let t = x(e);
		if (!t) return;
		R();
		let r = n.filter((e) => t[e] !== void 0), i = Ce(C.current);
		u && ne(t, u), B.current?.announce(t, i), N(ie(v.current, t, i)), P(r), F(r);
	}, [
		R,
		C,
		u,
		B,
		N,
		v,
		P,
		F
	]), le = f(() => {
		R(), O.current.retry();
	}, [R, O]);
	m(() => () => {
		j.current = null, A(null), O.current.clear();
	}, [M, O]), ge({
		stripQueryParams: a,
		localStateRef: v,
		writeToCookies: P,
		refresh: R
	}), Ie({
		ownerKey: M,
		hasPort: t !== void 0,
		ownerRef: C,
		portRef: w,
		onLoaded: z,
		onResume: le,
		report: E
	}), ye(d, V);
	let ue = h(() => ({
		...S,
		isSynced: k !== null && k === M,
		choose: V,
		refresh: R,
		setThemeMode: (e) => V({ themeMode: e }),
		setLanguage: (e) => V({ language: e }),
		setTimezone: (e) => V({ timezone: e })
	}), [
		S,
		k,
		M,
		V,
		R
	]);
	return /* @__PURE__ */ _(re.Provider, {
		value: ue,
		children: l
	});
}
//#endregion
//#region src/lib/row/corePort.ts
var Q = {
	themeMode: "theme",
	language: "language_code",
	timezone: "timezone"
};
function tt(e) {
	return De(e, [404]);
}
function nt(e) {
	return typeof e == "object" && e && "data" in e ? e.data : e;
}
function rt(e) {
	if (typeof e != "object" || !e) return !1;
	let t = e;
	return Object.values(Q).some((e) => typeof t[e] == "string");
}
function it(e) {
	return {
		themeMode: u(e.theme) ? e.theme : X.themeMode,
		language: c(e.language_code)?.language ?? s()?.language ?? i,
		timezone: b(e.timezone) ? e.timezone : X.timezone
	};
}
function $(e) {
	return {
		theme: e.themeMode,
		language_code: e.language,
		timezone: e.timezone
	};
}
function at(e, t) {
	let n = $(e);
	return t.map((e) => ({
		key: Q[e],
		value: n[Q[e]]
	}));
}
function ot({ http: e, baseUrl: t }) {
	let r = t.replace(/\/+$/, ""), i = (e) => e.kind === "external" ? `${r}/api/v1/external/identity/client/${encodeURIComponent(e.id)}/client-preferences` : `${r}/api/v1/client-preferences/client/${encodeURIComponent(e.id)}`;
	return {
		async load(t, n) {
			let r;
			try {
				r = await e.get(i(t), { signal: n });
			} catch (e) {
				if (tt(e)) return null;
				throw e;
			}
			let a = nt(r);
			if (!rt(a)) throw Error("[preferences] core answered without a preferences row");
			return it(a);
		},
		async save(t, r, a) {
			if (!(a !== void 0 && a.length > 0 && a.length < n.length)) {
				await e.put(i(t), $(r));
				return;
			}
			try {
				await e.patch(i(t), at(r, a));
			} catch (n) {
				if (!tt(n)) throw n;
				await e.put(i(t), $(r));
			}
		}
	};
}
//#endregion
export { S as EMBEDDED_CHOICE_MESSAGE_TYPE, r as PREFERENCES_AUTHOR_COOKIE_KEY, t as PREFERENCES_COOKIE_KEYS, e as PREFERENCES_QUERY_KEYS, w as PreferencesBridge, et as PreferencesProvider, ot as createCorePreferencesPort, C as usePreferences };
